import { MARQUEE } from "../data/content";

export const Marquee = ({ dark = true }) => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div className={`relative overflow-hidden py-5 ${dark ? "bg-forest text-gold" : "bg-gold text-forest"} -rotate-1 scale-[1.02] border-y border-white/10`} data-testid="marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((t, i) => (
          <span key={i} className="flex items-center font-heading font-extrabold text-xl sm:text-2xl uppercase tracking-[0.14em] px-6">
            {t}
            <span className={`ml-12 w-2.5 h-2.5 rounded-full ${dark ? "bg-african" : "bg-forest"}`} />
          </span>
        ))}
      </div>
    </div>
  );
};
